// frontend/src/main.tsx
import './instrument.ts'
import './root.css'
import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import ClientLayout from './modules/AppUi/ClientLayout.tsx'
import AppRoutes from './AppRoutes.tsx'
import { enableLogger } from './logger.ts'

enableLogger(
  typeof localStorage !== 'undefined'
    ? !!localStorage.getItem('debug_verbose')
    : false,
  ['pk', 'soniq'],
)

const container = document.getElementById('root')!
const tree = (
  <React.StrictMode>
    <ClientLayout>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </ClientLayout>
  </React.StrictMode>
)

if (container.firstElementChild) {
  hydrateRoot(container, tree)
} else {
  createRoot(container).render(tree)
}
